export default __webpack_public_path__ + "static/media/weasel.3a597fcd.png";